export default {"src":"/_next/static/media/start_bold.23a60463.svg","height":24,"width":24};